export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10796.49ea0d1d.jpg";